import React, { useState, useEffect } from "react";
import axios from "axios";
import { Plus, Edit2, Trash2, X, Check, Send } from "lucide-react";
import ImageUpload from "../../components/ImageUpload";
import MarkdownEditor from "../../components/MarkdownEditor";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const TYPE_LABELS = { news: "Новость", promotion: "Акция", collection: "Коллекция", vip: "VIP" };

const inputStyle = { background: "white", border: "1px solid #e5e7eb", borderRadius: "4px", padding: "10px 12px", fontFamily: "Manrope", fontSize: "14px", outline: "none", width: "100%", color: "#0A0A0A" };
const labelStyle = { fontFamily: "Manrope", fontSize: "11px", fontWeight: 700, color: "#6b7280", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "4px", display: "block" };

function NewsForm({ item, onSave, onClose }) {
  const [form, setForm] = useState(item || { title: "", content: "", type: "news", image_url: "", is_active: true, is_vip_only: false });
  const [notify, setNotify] = useState(false);
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSave = async () => {
    setLoading(true);
    try {
      if (item?.id) {
        await axios.put(`${API}/news/${item.id}`, form, { withCredentials: true });
      } else {
        const r = await axios.post(`${API}/news?notify=${notify}`, form, { withCredentials: true });
        if (notify && r.data?.push_stats) {
          alert(`Уведомление отправлено: ${r.data.push_stats.sent} клиентам`);
        }
      }
      onSave();
    } catch (err) {
      alert(err.response?.data?.detail || "Ошибка");
    } finally { setLoading(false); }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 100, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "20px", overflowY: "auto" }}>
      <div className="light-section" style={{ background: "white", borderRadius: "12px", width: "100%", maxWidth: "560px", padding: "24px", marginTop: "20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
          <h3 style={{ fontFamily: "Cormorant Garamond", fontSize: "22px", fontWeight: 400 }}>{item ? "Редактировать" : "Новая публикация"}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#888" }}><X size={20} /></button>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
          <div>
            <label style={labelStyle}>Заголовок</label>
            <input data-testid="news-title-input" value={form.title} onChange={e => set("title", e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Тип</label>
            <select value={form.type} onChange={e => set("type", e.target.value)} style={inputStyle}>
              {Object.entries(TYPE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
          <ImageUpload
            value={form.image_url ? [form.image_url] : []}
            onChange={imgs => set("image_url", imgs[0] || "")}
            maxImages={1}
            testId="news-image"
            label="Обложка публикации"
          />
          <div>
            <label style={labelStyle}>Текст</label>
            <MarkdownEditor
              value={form.content}
              onChange={v => set("content", v)}
              rows={8}
              testId="news-content-input"
              placeholder="Начните печатать или используйте кнопки выше:&#10;&#10;**Жирный текст** для акцентов&#10;- Пункт списка&#10;- Ещё пункт&#10;&#10;Ссылки https://... автоматически кликабельны"
            />
            <div style={{ fontFamily: "Manrope", fontSize: "11px", color: "#888", marginTop: "6px", lineHeight: 1.5 }}>
              Используйте панель сверху или клавиши <b>Ctrl+B</b> (жирный), <b>Ctrl+I</b> (курсив). Превью покажет как клиент увидит публикацию.
            </div>
          </div>
          <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
            <label style={{ display: "flex", alignItems: "center", gap: "6px", fontFamily: "Manrope", fontSize: "13px", cursor: "pointer" }}>
              <input type="checkbox" checked={form.is_active} onChange={e => set("is_active", e.target.checked)} />Активно
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: "6px", fontFamily: "Manrope", fontSize: "13px", cursor: "pointer" }}>
              <input type="checkbox" checked={form.is_vip_only} onChange={e => set("is_vip_only", e.target.checked)} />Только VIP
            </label>
            {!item && (
              <label data-testid="news-notify-checkbox" style={{ display: "flex", alignItems: "center", gap: "6px", fontFamily: "Manrope", fontSize: "13px", cursor: "pointer", color: "#C5A059", fontWeight: 600 }}>
                <input type="checkbox" checked={notify} onChange={e => setNotify(e.target.checked)} />
                <Send size={13} /> Отправить push клиентам, подписанным на уведомления
              </label>
            )}
          </div>
        </div>
        <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
          <button onClick={onClose} style={{ flex: 1, background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "6px", padding: "12px", cursor: "pointer", fontFamily: "Manrope", fontSize: "13px" }}>Отмена</button>
          <button data-testid="save-news-btn" onClick={handleSave} disabled={loading}
            style={{ flex: 2, background: "linear-gradient(135deg,#C5A059,#D4B878)", color: "#0A0A0A", border: "none", borderRadius: "6px", padding: "12px", cursor: "pointer", fontFamily: "Manrope", fontWeight: 700, fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
            <Check size={15} />{loading ? "Сохранение..." : "Опубликовать"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function AdminNews() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const load = () => {
    setLoading(true);
    axios.get(`${API}/news`, { withCredentials: true }).then(r => setNews(r.data)).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Удалить публикацию?")) return;
    await axios.delete(`${API}/news/${id}`, { withCredentials: true });
    load();
  };

  const handleNotify = async (item) => {
    if (!window.confirm(`Отправить push-уведомление ${item.is_vip_only ? "VIP-" : ""}клиентам, подписанным на уведомления?`)) return;
    try {
      const r = await axios.post(`${API}/news/${item.id}/notify`, {}, { withCredentials: true });
      if (r.data.ready === false) {
        alert("Firebase не настроен на сервере");
      } else {
        alert(`Уведомление отправлено: ${r.data.sent} клиентам (пропущено: ${r.data.skipped})`);
      }
    } catch (e) {
      alert(e.response?.data?.detail || "Ошибка отправки");
    }
  };

  const TYPE_COLORS = { news: "#60a5fa", promotion: "#C5A059", collection: "#4ade80", vip: "#e879f9" };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px" }}>
        <button data-testid="add-news-btn" onClick={() => { setEditing(null); setShowForm(true); }}
          style={{ background: "linear-gradient(135deg,#C5A059,#D4B878)", color: "#0A0A0A", border: "none", borderRadius: "6px", padding: "10px 20px", cursor: "pointer", fontFamily: "Manrope", fontWeight: 700, fontSize: "13px", display: "flex", alignItems: "center", gap: "6px" }}>
          <Plus size={16} />Добавить публикацию
        </button>
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: "40px", color: "#888", fontFamily: "Manrope" }}>Загрузка...</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {news.map(item => (
            <div key={item.id} data-testid={`admin-news-${item.id}`} style={{ background: "white", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "16px", display: "flex", gap: "16px", alignItems: "flex-start" }}>
              {item.image_url && <img src={item.image_url} alt={item.title} style={{ width: "80px", height: "60px", objectFit: "cover", borderRadius: "4px", flexShrink: 0 }} onError={e => { e.target.style.display = "none"; }} />}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", gap: "6px", marginBottom: "6px" }}>
                  <span style={{ background: `${TYPE_COLORS[item.type]}18`, color: TYPE_COLORS[item.type], fontFamily: "Manrope", fontSize: "10px", fontWeight: 700, padding: "2px 8px", borderRadius: "10px" }}>{TYPE_LABELS[item.type]}</span>
                  {item.is_vip_only && <span style={{ background: "#f3e8ff", color: "#9333ea", fontFamily: "Manrope", fontSize: "10px", fontWeight: 700, padding: "2px 8px", borderRadius: "10px" }}>VIP</span>}
                </div>
                <div style={{ fontFamily: "Cormorant Garamond", fontSize: "18px", color: "#0A0A0A", marginBottom: "4px" }}>{item.title}</div>
                <div style={{ fontFamily: "Manrope", fontSize: "12px", color: "#888", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{item.content}</div>
                <div style={{ fontFamily: "Manrope", fontSize: "11px", color: "#aaa", marginTop: "6px" }}>
                  {item.created_at ? new Date(item.created_at).toLocaleDateString("ru-RU") : ""}
                </div>
              </div>
              <div style={{ display: "flex", gap: "8px", flexShrink: 0 }}>
                <button onClick={() => handleNotify(item)} data-testid={`notify-news-${item.id}`}
                  title="Отправить push клиентам"
                  style={{ background: "rgba(197,160,89,0.15)", border: "1px solid rgba(197,160,89,0.4)", borderRadius: "4px", padding: "7px 10px", cursor: "pointer", color: "#92400e", display: "flex", alignItems: "center" }}>
                  <Send size={13} />
                </button>
                <button onClick={() => { setEditing(item); setShowForm(true); }} style={{ background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "4px", padding: "7px 10px", cursor: "pointer", color: "#374151", display: "flex", alignItems: "center" }}><Edit2 size={13} /></button>
                <button onClick={() => handleDelete(item.id)} style={{ background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: "4px", padding: "7px 10px", cursor: "pointer", color: "#dc2626", display: "flex", alignItems: "center" }}><Trash2 size={13} /></button>
              </div>
            </div>
          ))}
        </div>
      )}

      {showForm && <NewsForm item={editing} onSave={() => { setShowForm(false); load(); }} onClose={() => setShowForm(false)} />}
    </div>
  );
}
